import { PriceRangeDto } from '@/features/shared/pricing/types/PriceRangeDto.ts';
import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { EstimatedPriceDto } from '@/features/public/booking/types/BookingQuoteDto.ts';

export const getEstimatedPricesString = (
  dtos?: EstimatedPriceDto[],
): string => {
  if (!dtos || dtos.length === 0) {
    return '--';
  }
  return dtos.map(getEstimatedPriceString).join(' + ');
};

export const getEstimatedPriceString = (dto: EstimatedPriceDto): string => {
  const price = `${dto.amount.amount} ${dto.amount.currency}`;
  return dto.precise ? price : `od ${price}`;
};

//TO change this for commpoennt with nice rendering of price
export const getRangePricesRangeString = (dtos?: PriceRangeDto[]): string => {
  if (!dtos || dtos.length === 0) {
    return '--';
  }
  return dtos.map(getRangePriceRangeString).join(' + ');
};

export const getRangePriceRangeString = (dto: PriceRangeDto): string => {
  if (dto.min.amount === dto.max.amount) {
    return `${dto.max.amount} ${dto.max.currency} `;
  } else {
    return `( ${dto.min.amount} - ${dto.max.amount} ) ${dto.max.currency}`;
  }
};

// todo move it to proper place
export const getPricesDisplayString = (prices: MoneyValueDto[]): string => {
  if (prices.length === 0) {
    return '';
  } else if (prices.length === 1) {
    return `${prices[0].amount} ${prices[0].currency}`;
  }

  // for now we support only 1 currency
  const currency = prices[0].currency;
  const minPrice = prices.sort((a, b) => a.amount - b.amount)[0].amount;
  return `od ${minPrice} ${currency}`;
};

export const sumPricesDisplayString = (prices: MoneyValueDto[]): string => {
  if (prices.length === 0) {
    return '';
  }

  // Group prices by currency and sum them
  const currencySums = prices.reduce(
    (acc, price) => {
      const currency = price.currency;
      acc[currency] = (acc[currency] || 0) + price.amount;
      return acc;
    },
    {} as Record<string, number>,
  );

  // Format as "260 PLN, 200 EUR"
  return Object.entries(currencySums)
    .map(([currency, amount]) => `${amount} ${currency}`)
    .join(', ');
};
